import { Inject, Injectable } from '@angular/core';
import { isNil } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

@Injectable({ providedIn: 'root' })
export class Inventory_ds_get_measurement_unit_by_unitIdService {

  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    ) { 
  }

  public async get($inParams: { unitId: number }): 
  Promise<{ result: { Id?: number, Name?: string, Short_name?: string } }> 
  {
    const $missingRequiredInParams = [];
    if (isNil($inParams.unitId)) {
      $missingRequiredInParams.push('\'unitId\'');
    }
    if ($missingRequiredInParams.length) {
    }
    let $url = `${environment.backendUrl}api/`;
    
    const $options = {
    }
    
    const $body = $inParams;
    
    return this.$utils.http.post($url, $body, $options);
    
  }


    
    hasMissingRequiredInParams($inParams: { 
      unitId: number    }) {
        if(isNil($inParams.unitId)) {
          return true; 
        }
      return false;
    }
}
